import { useCallback, useState } from 'react';

import { LayoutChangeEvent } from 'react-native';

import { spacing } from 'styles/constants';
import { isIos } from 'utils/environment';

const KEYBOARD_AWARE_FOOTER_INPUT_MARGIN = spacing.$8;

interface UseKeyboardAwareFooterOptions {
  enabled?: boolean;
}

export const useKeyboardAwareFooter = ({ enabled = false }: UseKeyboardAwareFooterOptions = {}) => {
  const [footerHeight, setFooterHeight] = useState(0);
  const isKeyboardAwareFooterEnabled = enabled && isIos;

  const onFooterLayout = useCallback((event: LayoutChangeEvent) => {
    const nextFooterHeight = event.nativeEvent.layout.height;
    setFooterHeight(currentFooterHeight =>
      currentFooterHeight === nextFooterHeight ? currentFooterHeight : nextFooterHeight
    );
  }, []);

  const bottomOffset = isKeyboardAwareFooterEnabled
    ? footerHeight + KEYBOARD_AWARE_FOOTER_INPUT_MARGIN
    : 0;

  return {
    bottomOffset,
    isKeyboardAwareFooterEnabled,
    onFooterLayout,
  };
};
